import React from 'react'
import { useNavigate } from 'react-router-dom'

const SubHeader = ({ message }) => {
    const navigate = useNavigate();

    return (
        <>
            <section className='banner2-bg'>
                <div className='container text-center'>
                    <p className='subheader-text'>{message}</p>
                    <button  className='subheader-btn'><span className='subheader-link' onClick={() => navigate('/')} >Home</span>
                    <i class="fa-solid fa-arrow-right mx-2"></i>{message}</button>
                </div>
            </section>
        </>
    )
}

export default SubHeader
